import {
  Typography,
  Alert,
  FormControl,
  TextField,
  Button,
  LinearProgress,
  Switch,
  Select,
  MenuItem,
  InputLabel,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Chip,
  Card,
  Stack,
  Tooltip,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Grid from '@mui/material/Unstable_Grid2';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useContext, useEffect, useState } from 'react';
import {
  CreateOrEditMerchantProps,
  MerchantType,
} from '../../../../interfaces/delivery-company/merchants';
import InvoiceFrequencySection from '../invoice-frequency-section/invoice-frequency-section';
import InvoiceFrequencyDialog from '../invoice-frequency-section/invoice-frequency-dialog';
import MuiPhoneNumber from 'mui-phone-number';
import ConfirmAction from '../../../common/confirm-action/confirm-action';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import axios, { AxiosResponse } from 'axios';
import {
  API_ENDPOINT,
  primaryPaletteColor,
} from '../../../../configurations/global.config';
import { emptyMerchant } from '../../../../data/merchants';
import { UserType } from '../../../../enums/users';
import AddressInputWithAutocomplete from '../../../common/adress-input-with-autocomplete/address-input-with-autocomplete';
import { NotificationMode } from '../../../../enums/notifications';
import { display_notification_mode } from '../../../../utils/notification_mode_icons';
import { ErrorsFlattenner } from '../../../common/errors-flattenner/errors-flattenner';
import MoneyInput from '../../../common/money-input/money-input';
import { displayMoney, Money } from '../../../../utils/money';
import Grid2 from '@mui/material/Unstable_Grid2';
import { MuiTelInput } from 'mui-tel-input';
import GenericTable from '../../../common/generic-table/generic-table';
import { ShopLocationType } from '../../../../interfaces/delivery-company/pickups';
import { IconButton } from '@mui/material';
import { Delete, DeleteOutline, MonetizationOn, MoneyOff, MoneyOutlined, PhotoCamera } from '@mui/icons-material'; // You can use any icon from Material UI
import CreatePickupLocationForm from '../../pickup-location-form/pickup-location-form';
import { ClearIcon } from '@mui/x-date-pickers';
import ImageIcon from '@mui/icons-material/Image';
import { isMobile, isTablet } from 'react-device-detect';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';
import { useSnackBar } from '../../../../contexts/snackbar';
import { displayLocation } from '../../../../utils/locations';
import DeliveryChargeOverrides from '../delivery-charge-rules/delivery-charge-overrides';
import { MerchantWithIcon } from '../../../common/styles/merchant-with-icon';
import UpdateCOD from '../../failed-deliveries-receiver/update-cod';
import DeliveryChargeOverridesDialog from './delivery-charge-overrides-dialog';
import CriticalOrderCreditSection from '../critical-order-credit-section/critical-order-credit-section';
import { useSearchParams } from 'react-router-dom';
import MerchantInvitation from './merchant-invite';
import { useTabPersistedState } from '../../../common/tabPersistedState/tab-persisted-state';
import ImageUploader from '../../../common/image-upload/logo-uploader';
import { toast } from 'react-toastify';
import { DataResources, ResourceActionType, user_has_data_model_access } from '../../../../utils/permissions';
import TextFieldWithArabicKeyboard from '../../../common/text-field-with-arabic-keyboard';

function CreateMerchantForm({
  defaultMerchant,
  successCallback,
  headless,
}: CreateOrEditMerchantProps) {
  console.log(defaultMerchant);
  const [merchantData, setMerchantData] = useState<MerchantType | undefined>(
    defaultMerchant || emptyMerchant
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>('');
  const [confirmDeleteMerchant, setConfirmDeleteMerchant] =
    useState<boolean>(false);
  const [response, setResponse] = useState<AxiosResponse>();
  const [message, setMessage] = useState<string>('');
  const [enableModifyPassword, setEnableModifyPassword] =
    useState<boolean>(false);
  const [error, setError] = useState(false);
  const { user, config } = useContext(AuthContext);

  const [editingPickup, setEditingPickup] = useState<ShopLocationType>();
  const [creatingPickup, setCreatingPickup] = useState<boolean>(false);

  const [configuringOverrides, setConfiguringOverrides] = useTabPersistedState('configuringOverrides', false);
  const [configuringInvoiceFrequency, setConfiguringInvoiceFrequency] = useState<boolean>(false);

  console.log('check: ', user);
  const canChangeMerchant = user_has_data_model_access(user, DataResources.MERCHANT, ResourceActionType.UPDATE);

  const canCreateMerchant = user_has_data_model_access(user, DataResources.MERCHANT, ResourceActionType.CREATE);

  const canDeleteMerchant = user_has_data_model_access(user, DataResources.MERCHANT, ResourceActionType.DELETE);

  const { showMessage } = useSnackBar();

  console.log(merchantData);

  console.log('checkpoiny');

  const handleSubmit = async (merchantData: MerchantType) => {
    if (merchantData) {
      setIsLoading(true);
      setResponse(undefined);
      setLoadingMessage('Saving Merchant...');
      const requestData = {
        name: merchantData.name,
        phone_number: merchantData.phone_number,
        address: merchantData.address,
        organisation: user?.organisation,
        password: merchantData.password,
        notification_mode: merchantData.notification_mode,
        default_delivery_fee: merchantData.default_delivery_fee,
        default_return_fee: merchantData.default_return_fee,
        logo_url: merchantData.logo_url,
        show_package_description_in_invoice: merchantData.show_package_description_in_invoice,
      };

      console.log(requestData);

      try {
        let response;
        const endpoint = `${API_ENDPOINT}/api/v1/merchant/${merchantData.id}/`;

        if (merchantData.id === '') {
          console.log('request data:', requestData);
          // create new
          response = await axios.post<MerchantType>(
            `${API_ENDPOINT}/api/v1/merchants/`,
            requestData,
            config
          );
        } else {
          // edit existing
          response = await axios.put(endpoint, requestData, config);
        }
        setResponse(response);
        console.log(response);
        setMerchantData(response.data)

        showMessage('Merchant saved successfully');
        successCallback && successCallback(response.data);
      } catch (e: any) {
        if (axios.isAxiosError(e)) {
          setResponse(e.response);
          setMessage('Failed to save merchant: ' + e.message);
        } else {
          setMessage('Failed to save merchant');
        }
        console.log(e);
      }
      setIsLoading(false);
      setLoadingMessage('');
    }
  };

  const handleMakeLocationDefault = async (pickupId: string) => {
    if (merchantData) {
      setIsLoading(true);
      setResponse(undefined);
      const requestData = {
        is_default: true,
      };
      try {
        const endpoint = `${API_ENDPOINT}/api/v1/pickup/${pickupId}/`;
        await axios.patch(endpoint, requestData, config);
        showMessage('Updated default location');
        const new_pickups = merchantData.shop_locations.map((item) => {
          return { ...item, is_default: item.id == pickupId };
        });
        setMerchantData({ ...merchantData, shop_locations: new_pickups });
      } catch (e: any) {
        showMessage('Failed to update default shop location', 'error');
      }
      setIsLoading(false);
    }
  };

  const deleteMerchant = async () => {
    if (merchantData && merchantData.id !== '') {
      setIsLoading(true);
      setResponse(undefined);
      try {
        const response = await axios.delete(
          `${API_ENDPOINT}/api/v1/merchant/${merchantData.id}/`,
          config
        );
        setResponse(response);
        if (response.status === 204) {
          setMerchantData({...merchantData, is_active: false});
          setMessage('Merchant deactivated successfully');
        }
      } catch (e) {
        if (axios.isAxiosError(e)) {
          setResponse(e.response);
          setMessage('Failed to deactivate merchant: ' + e.message);
        } else {
          setMessage('Failed to deactivate merchant');
        }
        console.log(e);
      }

      setIsLoading(false);
    }
  };

  const activateMerchant = async () => {
    if (merchantData && merchantData.id !== '') {
      setIsLoading(true);
      setResponse(undefined);
      try {
        const response = await axios.post(
          `${API_ENDPOINT}/v1/merchant/${merchantData.id}/activate/`,
          {},
          config
        );
        setResponse(response);
          setMerchantData({...merchantData, is_active: true});
          showMessage('Merchant activated successfully', 'success');
      } catch (e) {
        if (axios.isAxiosError(e)) {
          setResponse(e.response);
          showMessage('Failed to activate merchant', 'error');
          setMessage('Failed to activate merchant: ' + e.message);
        } else {
          showMessage('Failed to activate merchant', 'error');
        }
        console.log(e);
      }

      setIsLoading(false);
    }
  };

  return (
    <>
      {!headless && (
        <Typography variant="h3" component="h3" sx={{ textAlign: 'center' }}>
          {defaultMerchant === undefined ? 'Create Merchant' : 'Edit Merchant'}
        </Typography>
      )}

      {isLoading ? (
        <>
          {loadingMessage}
          <br />
          <LinearProgress />
        </>
      ) : (
        <>
          {message !== '' && (
            <Alert
              severity={
                response && response.status >= 200 && response.status < 300
                  ? 'success'
                  : 'error'
              }
            >
              {message}

              {response && response.status >= 300 && (
                <ErrorsFlattenner rawErrors={response.data} />
              )}
            </Alert>
          )}

          {merchantData && (
            <>
              <br></br>
              <Grid2 container spacing={4}>
                <Grid2 xs={12} md={defaultMerchant !== undefined ? 6 : 12}>
                  <form onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit(merchantData)
                  }}>
                    <FormControl fullWidth>
                      <TextFieldWithArabicKeyboard
                        autoComplete="off"
                        label="Merchant Name"
                        type="text"
                        variant="outlined"
                        required
                        value={merchantData.name}
                        onChange={(v) =>
                          setMerchantData({
                            ...merchantData,
                            name: v,
                          })
                        }
                      />
                    </FormControl>
                    <br />
                    <br />
                    <FormControl fullWidth>
                      <MuiTelInput
                        autoComplete="off"
                        forceCallingCode
                        label="Phone Number"
                        disabled={isLoading}
                        defaultCountry={'LB'}
                        variant="outlined"
                        required
                        value={merchantData.phone_number}
                        onChange={(newPhone) => {
                          if (typeof newPhone === 'string') {
                            setMerchantData({
                              ...merchantData,
                              phone_number: newPhone,
                            });
                          }
                        }}
                      />
                    </FormControl>
                    <br />
                    <br />
                    <FormControl fullWidth>
                      <AddressInputWithAutocomplete
                        label="Address"
                        initialAddress={merchantData.address}
                        callback={(
                          address,
                          district,
                          governorate,
                          url,
                          place_id
                        ) => {
                          setMerchantData((prev) => {
                            return {
                              ...(prev ?? emptyMerchant),
                              address: address,
                            };
                          });
                        }}
                        overrideAddress={(val) =>
                          setMerchantData((prev) => {
                            return {
                              ...(prev ?? emptyMerchant),
                              address: val,
                            };
                          })
                        }
                      />
                    </FormControl>
                    <br />
                    <br />
                <Grid2 container spacing={2}>
                  {/* Row 1: Default Delivery Fee and Default Return Fee */}
                  <Grid2 xs={12} md={6}>
                    <MoneyInput
                      money={merchantData.default_delivery_fee}
                      setMoney={(money) =>
                        setMerchantData({
                          ...merchantData,
                          default_delivery_fee: money,
                        })
                      }
                      label={'Default Delivery Fee'}
                    />
                  </Grid2>

                  <Grid2 xs={12} md={6}>
                    <MoneyInput
                      money={merchantData.default_return_fee}
                      setMoney={(money) =>
                        setMerchantData({
                          ...merchantData,
                          default_return_fee: money,
                        })
                      }
                      label={'Default Return Fee'}
                      footer={<Typography mt={1} align='center' variant='subtitle2'>Charges applied on orders returned after failed delivery attempts.</Typography>}
                    />
                  </Grid2>

                  {/* Row 2: Delivery Fee Rules and Critical Order Credits */}
                  {defaultMerchant && (
                    <>
                      <Grid2 xs={12} md={6}>
                        <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
                          <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="subtitle1" gutterBottom>
                              Delivery Fee Rules
                            </Typography>
                          </Box>
                          <Typography variant="body2" color="textSecondary">
                            Set custom delivery fees based on governorate, district or destination area.
                          </Typography>
                          <Box mt={2}>
                            <Button
                              onClick={() => setConfiguringOverrides(true)}
                              startIcon={<MonetizationOn />}
                              variant="contained"
                              disabled={!user_has_data_model_access(user, DataResources.DELIVERY_FEE_RULES, ResourceActionType.VIEW)}
                            >
                              Configure Rules
                            </Button>
                          </Box>
                        </Card>
                      </Grid2>

                      <Grid2 xs={12} md={6}>
                        <CriticalOrderCreditSection
                          merchant={merchantData}
                          canEdit={canChangeMerchant}
                          onUpdate={(updatedMerchant) => {
                            setMerchantData(updatedMerchant);
                          }}
                        />
                      </Grid2>
                    </>
                  )}

                  {/* Row 3: Invoice Frequency */}
                  {defaultMerchant && (
                    <Grid2 xs={12} md={6}>
                      <InvoiceFrequencySection
                        merchant={merchantData}
                        canEdit={canChangeMerchant}
                        onUpdate={(updatedMerchant) => {
                          setMerchantData(updatedMerchant);
                        }}
                        onOpenDialog={() => setConfiguringInvoiceFrequency(true)}
                      />
                    </Grid2>
                  )}
                </Grid2>
                    
                    <br />
                    <Box>
                      <Switch checked={merchantData.show_package_description_in_invoice} onChange={()=>setMerchantData({...merchantData, show_package_description_in_invoice: !merchantData.show_package_description_in_invoice})} /> Include package description in invoices.
                    </Box>

                    <br />

                    <div style={{ display: 'flex', gap: 7 }}>
                      <Button
                        size={(isMobile && !isTablet) ? 'small' : 'medium'}
                        type="submit"
                        variant="contained"
                        disabled={
                          (merchantData.id !== '' && !canChangeMerchant) ||
                          (merchantData.id === '' && !canCreateMerchant)
                        }
                      >
                        Save Merchant
                      </Button>

                      {merchantData.id !== '' && (
                        
                          merchantData.is_active ? <Button
                              size={(isMobile && !isTablet) ? 'small' : 'medium'}
                              onClick={deleteMerchant}
                              disabled={!canDeleteMerchant && !canChangeMerchant}
                              variant="outlined"
                              color="error"
                            >
                              Deactivate
                            </Button> 
                        :
                          <Button
                            size={(isMobile && !isTablet) ? 'small' : 'medium'}
                            onClick={activateMerchant}
                            disabled={!canDeleteMerchant && !canChangeMerchant}
                            variant="outlined"
                            color="info"
                           >
                          Reactivate
                        </Button>
                      )}
                    </div>
                  </form>
                </Grid2>

                {defaultMerchant != undefined && (
                  <Grid2 xs={12} md={6} sx={{ textAlign: 'center' }}>
                    <Typography
                      variant="h5"
                      component="h5"
                      sx={{ textAlign: 'center' }}
                    >
                      Logo {merchantData.logo_url && <IconButton disabled={!canChangeMerchant} onClick={(e)=>handleSubmit({...merchantData, logo_url: null})}> <Delete color={!canChangeMerchant ? "inherit" : "error"} /></IconButton>}
                    </Typography>

                    <ImageUploader 
                      onUploaded={(url)=> {
                        handleSubmit({...merchantData, logo_url: url})
                      }}
                      defaultImageUrl={merchantData.logo_url ?? undefined}
                      disabled={!canChangeMerchant}
                    />

                    <Typography
                      variant="h5"
                      component="h5"
                      sx={{ textAlign: 'center' }}
                    >
                      Pickup Locations
                      <IconButton
                        size="large"
                        color="primary"
                        onClick={() => setCreatingPickup(true)}
                        disabled={!canChangeMerchant}
                      >
                        <AddIcon />
                      </IconButton>
                    </Typography>
                    <br />

                    {merchantData.shop_locations && (
                      <GenericTable
                        sourceView="merchant-forms-create-or-edit-merchant"
                        items={merchantData.shop_locations}
                        isLoading={isLoading}
                        selectedItems={new Map<string, ShopLocationType>()}
                        fullWidth
                        columns={[
                          {
                            id: 'name',
                            header: 'Location',
                            display_body: (pickup: ShopLocationType) => (
                              <div
                                style={{ cursor: 'pointer' }}
                                onClick={() => setEditingPickup(pickup)}
                              >
                                <b>{pickup.name} </b>
                                <br /> {displayLocation(pickup)}
                              </div>
                            ),
                          },
                          {
                            id: 'make_default',
                            header: 'Default',
                            display_body: (pickup: ShopLocationType) =>
                              pickup.is_default ? (
                                <span
                                  style={{ color: 'green', fontWeight: 'bold' }}
                                >
                                  ✅ Default
                                </span>
                              ) : (
                                <Button
                                  color="primary"
                                  size="small"
                                  disabled={!canChangeMerchant}
                                  onClick={() =>
                                    handleMakeLocationDefault(pickup.id)
                                  }
                                >
                                  Set as Default
                                </Button>
                              ),
                          },
                          {
                            id: 'contact_person',
                            header: 'Contact Person',
                            display_body: (pickup: ShopLocationType) => (
                              <p>{pickup.contact_person} </p>
                            ),
                          },
                          {
                            id: 'contact_phone',
                            header: 'Contact Phone',
                            display_body: (pickup: ShopLocationType) => (
                              <p>{pickup.contact_phone} </p>
                            ),
                          },
                        ]}
                        getItemUID={(pickup) => pickup.id}
                        updateSelectedItems={function (
                          updater: (
                            draft: Map<string, ShopLocationType>
                          ) => void
                        ): void {
                          throw new Error('Function not implemented.');
                        }}
                      />
                    )}
                  </Grid2>
                )}
              </Grid2>
            </>
          )}
        </>
      )}

      { configuringOverrides && <DeliveryChargeOverridesDialog onClose={()=>setConfiguringOverrides(false)} merchant={merchantData!}/>}
      
      { configuringInvoiceFrequency && merchantData && (
        <InvoiceFrequencyDialog 
          open={configuringInvoiceFrequency}
          onClose={() => setConfiguringInvoiceFrequency(false)}
          merchant={merchantData}
          onUpdate={(updatedMerchant) => {
            console.log('Parent received updated merchant:', updatedMerchant);
            setMerchantData(updatedMerchant);
          }}
        />
      )}

      <CustomDialog
        fullWidth
        open={editingPickup != undefined}
        onClose={() => setEditingPickup(undefined)}
        fullScreen={(isMobile && !isTablet)}
      >
        <div
          style={{
            textAlign: 'right',
            width: '100%',
          }}
        >
          <IconButton onClick={() => setEditingPickup(undefined)}>
            <ClearIcon color="primary" fontSize="large" />
          </IconButton>
        </div>

        <DialogContent>
          <CreatePickupLocationForm
            defaultPickupId={editingPickup?.id}
            merchant={merchantData}
            successCallback={(p) => {
              if (merchantData)
                setMerchantData({
                  ...merchantData,
                  shop_locations: merchantData.shop_locations.map(
                    (current_pickup) =>
                      current_pickup.id === p.id ? p : current_pickup
                  ),
                });
            }}
          />
        </DialogContent>
      </CustomDialog>

     {
      
     }
      <CustomDialog
        fullWidth
        open={creatingPickup}
        fullScreen={(isMobile && !isTablet)}
        onClose={() => setCreatingPickup(false)}
      >
        <div
          style={{
            textAlign: 'right',
            width: '100%',
          }}
        >
          <IconButton onClick={() => setCreatingPickup(false)}>
            <ClearIcon color="primary" fontSize="large" />
          </IconButton>
        </div>

        <DialogContent>
          <CreatePickupLocationForm
            merchant={merchantData}
            successCallback={(p) => {
              if (merchantData)
                setMerchantData({
                  ...merchantData,
                  shop_locations: [p, ...merchantData.shop_locations],
                });
            }}
          />
        </DialogContent>
      </CustomDialog>
    </>
  );
}

export default CreateMerchantForm;
